import { render, staticRenderFns } from "./HabilitarTensao.vue?vue&type=template&id=972d94ea"
import script from "./HabilitarTensao.vue?vue&type=script&lang=js"
export * from "./HabilitarTensao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports